module.exports = __webpack_public_path__ + "img/visitor.5964c6ff.png";